namespace RioERP.Reports {
    export interface B2BRow {
        Id?: number;
        InvoiceDate?: string;
        Invoicenumber?: string;
        EPaymentType?: RioErp.Web.Enums.PaymentType;
        CustomerName?: string;
        StateName?: string;
        Quantity?: number;
        Views?: Web.Enums.EOpens;
        Validity?: Web.Enums.EValidity;
        SpecificationName?: string;
        HsnCode?: string;
        TaxCategoryName?: string;
        ProductName?: string;
        TaxableAmount?: number;
        CgstAmount?: number;
        SgstAmount?: number;
        IgstAmount?: number;
        NetAmount?: number;
        OrderNumber?: string;
        FranchiseeDiscountAmount?: number;
        City?: string;
        FranchiseeId?: number;
        Gstin?: string;
        OrderDate?: string;
    }

    export namespace B2BRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Invoicenumber';
        export const localTextPrefix = 'Reports.B2B';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            InvoiceDate = "InvoiceDate",
            Invoicenumber = "Invoicenumber",
            EPaymentType = "EPaymentType",
            CustomerName = "CustomerName",
            StateName = "StateName",
            Quantity = "Quantity",
            Views = "Views",
            Validity = "Validity",
            SpecificationName = "SpecificationName",
            HsnCode = "HsnCode",
            TaxCategoryName = "TaxCategoryName",
            ProductName = "ProductName",
            TaxableAmount = "TaxableAmount",
            CgstAmount = "CgstAmount",
            SgstAmount = "SgstAmount",
            IgstAmount = "IgstAmount",
            NetAmount = "NetAmount",
            OrderNumber = "OrderNumber",
            FranchiseeDiscountAmount = "FranchiseeDiscountAmount",
            City = "City",
            FranchiseeId = "FranchiseeId",
            Gstin = "Gstin",
            OrderDate = "OrderDate"
        }
    }
}
